import { IncomeStatement } from "./income-statement";

export class LocationRentAdjustment {
    ID: string;
    INCOME_STATEMENT: IncomeStatement;
    VALUE: number;
    LOCATION_ID: string;

    static parse(json: any): LocationRentAdjustment {
        if (json) {
            const lra = new LocationRentAdjustment();

            lra.ID = json.ID;
            lra.VALUE = json.VALUE;
            lra.LOCATION_ID = json.LOCATION_ID;

            if (json.INCOME_STATEMENT)
                lra.INCOME_STATEMENT = IncomeStatement.parse(json.INCOME_STATEMENT);

            return lra;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<LocationRentAdjustment> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(LocationRentAdjustment.parse(j));

        return arr;
    }

}
